import { createReducer, createActions } from 'reduxsauce'
import {
  initialFeedback,
  requestFeedback,
  successFeedback,
  failureFeedback,
} from 'reducers/utils'

const INITIAL_STATE = {
  status: null,
  statusFeedback: initialFeedback(),
  deals: { count: 0, results: [] },
  dealsFeedback: initialFeedback(),
  ledger: { count: 0, results: [] },
  ledgerFeedback: initialFeedback(),
  // the advisor's period ladder, newest-first — empty until (and unless)
  // `/v1/pap/periods/` answers; MoneyPages/fiscalPeriods falls back to the
  // civil ladder while it does not
  periods: [],
  periodsFeedback: initialFeedback(),
  // one period of "Mis cierres", zoned by the server: `{period, summary,
  // results}` — see MoneyPages/closings
  closings: null,
  closingsFeedback: initialFeedback(),
  // `/v1/pap/closings/` 404s until its backend PR is deployed. A 404 (and
  // ONLY a 404) turns this off for the session so "Mis cierres" stops asking
  // and rebuilds the period from the legacy sources instead.
  closingsSupported: true,
}

const { Types, Creators } = createActions(
  {
    getPapStatusRequest: [],
    getPapStatusSuccess: ['status'],
    getPapStatusFailure: ['errors'],
    getPapDealsRequest: ['params'],
    getPapDealsSuccess: ['count', 'results'],
    getPapDealsFailure: ['errors'],
    getPapLedgerRequest: ['params'],
    getPapLedgerSuccess: ['count', 'results'],
    getPapLedgerFailure: ['errors'],
    getPapPeriodsRequest: [],
    getPapPeriodsSuccess: ['periods'],
    getPapPeriodsFailure: ['errors'],
    getPapClosingsRequest: ['params'],
    getPapClosingsSuccess: ['closings'],
    getPapClosingsFailure: ['errors'],
  },
  { prefix: 'PAP_' },
)

const HANDLERS = {
  [Types.GET_PAP_STATUS_REQUEST]: state => ({
    ...state,
    statusFeedback: requestFeedback(),
  }),
  [Types.GET_PAP_STATUS_SUCCESS]: (state, { status }) => ({
    ...state,
    status,
    statusFeedback: successFeedback(),
  }),
  [Types.GET_PAP_STATUS_FAILURE]: (state, { errors }) => ({
    ...state,
    statusFeedback: failureFeedback(errors),
  }),
  [Types.GET_PAP_DEALS_REQUEST]: state => ({
    ...state,
    dealsFeedback: requestFeedback(),
  }),
  [Types.GET_PAP_DEALS_SUCCESS]: (state, { count, results }) => ({
    ...state,
    deals: { count, results },
    dealsFeedback: successFeedback(),
  }),
  [Types.GET_PAP_DEALS_FAILURE]: (state, { errors }) => ({
    ...state,
    dealsFeedback: failureFeedback(errors),
  }),
  [Types.GET_PAP_LEDGER_REQUEST]: state => ({
    ...state,
    ledgerFeedback: requestFeedback(),
  }),
  [Types.GET_PAP_LEDGER_SUCCESS]: (state, { count, results }) => ({
    ...state,
    ledger: { count, results },
    ledgerFeedback: successFeedback(),
  }),
  [Types.GET_PAP_LEDGER_FAILURE]: (state, { errors }) => ({
    ...state,
    ledgerFeedback: failureFeedback(errors),
  }),
  [Types.GET_PAP_PERIODS_REQUEST]: state => ({
    ...state,
    periodsFeedback: requestFeedback(),
  }),
  [Types.GET_PAP_PERIODS_SUCCESS]: (state, { periods }) => ({
    ...state,
    periods: periods || [],
    periodsFeedback: successFeedback(),
  }),
  [Types.GET_PAP_PERIODS_FAILURE]: (state, { errors }) => ({
    ...state,
    periods: [],
    periodsFeedback: failureFeedback(errors),
  }),
  [Types.GET_PAP_CLOSINGS_REQUEST]: state => ({
    ...state,
    closingsFeedback: requestFeedback(),
  }),
  [Types.GET_PAP_CLOSINGS_SUCCESS]: (state, { closings }) => ({
    ...state,
    closings,
    closingsFeedback: successFeedback(),
  }),
  [Types.GET_PAP_CLOSINGS_FAILURE]: (state, { errors }) => ({
    ...state,
    closings: null,
    // a 404 means "not deployed yet", not "this advisor has no closings":
    // only that answer switches the tab to its legacy sources
    closingsSupported: !errors || errors.errorResponseStatus !== 404,
    closingsFeedback: failureFeedback(errors),
  }),
}

export const PapActionTypes = Types
export const PapActionCreators = Creators

export default createReducer(INITIAL_STATE, HANDLERS)
